import React, { useState } from 'react';
import { DataTable } from '../components/DataTable';
import { WizardForm } from '../components/WizardForm';
import { StatusBadge } from '../components/StatusBadge';
import { UserIcon } from 'lucide-react';
import { beneficiaries } from '../data/beneficiaries';
export function BeneficiaryRegistry() {
  const [activeTab, setActiveTab] = useState<'list' | 'add' | 'approval'>('list');
  const [currentStep, setCurrentStep] = useState(0);
  // Form State
  const [formData, setFormData] = useState({
    photo: '',
    fullName: '',
    fatherName: '',
    spouseName: '',
    nid: '',
    birthCertNo: '',
    dob: '',
    age: '',
    gender: '',
    education: '',
    profession: '',
    experience: '',
    groupName: '',
    prevPermit: '',
    division: '',
    village: '',
    union: '',
    upazila: '',
    district: '',
    range: '',
    station: '',
    bloodGroup: '',
    phone: '',
    email: '',
    nidAttachment: '',
    birthCertAttachment: '',
    educationAttachment: ''
  });
  const stationsByRange: Record<string, string[]> = {
    'Satkhira Range': ['Burigoalini Station', 'Kaikhali Station', 'Dobeki Station'],
    'Khulna Range': ['Nalian Station', 'Patkosta Station', 'Karamjal Station'],
    'Chandpai Range': ['Harbaria Station', 'Joymoni Station', 'Tamulbunia Station'],
    'Sarankhola Range': ['Supati Station', 'Sharankhola Station', 'Kotka Station']
  };
  // beneficiaries imported from ../data/beneficiaries
  const pendingApprovals = [{
    photo: '👤',
    name: 'Nur Islam',
    nid: '6789012345678',
    profession: 'Jele (Fisher)',
    village: 'Munshiganj',
    date: '2024-03-30'
  }, {
    photo: '👤',
    name: 'Habib Mollah',
    nid: '7890123456789',
    profession: 'Bawali (Wood)',
    village: 'Gabura',
    date: '2024-03-29'
  }];
  const columns = [{
    key: 'name',
    label: 'Display Name'
  }, {
    key: 'email',
    label: 'Email ID'
  }, {
    key: 'nid',
    label: 'ID Number'
  }, {
    key: 'phone',
    label: 'Phone Number'
  }, {
    key: 'status',
    label: 'Status',
    render: (value: string) => <StatusBadge status={value as any} data-id="element-162" />
  }];
  const approvalColumns = [{
    key: 'photo',
    label: 'Photo',
    render: (value: string) => <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-xl" data-id="element-163">
          {value}
        </div>
  }, {
    key: 'name',
    label: 'Name'
  }, {
    key: 'nid',
    label: 'NID'
  }, {
    key: 'profession',
    label: 'Profession'
  }, {
    key: 'village',
    label: 'Village'
  }, {
    key: 'date',
    label: 'Applied Date'
  }];
  const filters = [{
    key: 'profession',
    label: 'Profession',
    options: ['Jele (Fisher)', 'Moual (Honey)', 'Bawali (Wood)']
  }, {
    key: 'status',
    label: 'Status',
    options: ['Approved', 'Pending', 'Rejected']
  }, {
    key: 'village',
    label: 'Village',
    options: ['Munshiganj', 'Gabura', 'Shyamnagar', 'Koyra', 'Dacope']
  }];
  const wizardSteps = [{
    title: 'Personal Info',
    description: 'Enter beneficiary personal information'
  }, {
    title: 'Address & Contact',
    description: 'Enter address and contact details'
  }, {
    title: 'Professional Details',
    description: 'Enter professional information'
  }, {
    title: 'Documents',
    description: 'Upload required documents'
  }, {
    title: 'Review & Submit',
    description: 'Review all information before submitting'
  }];
  return <div className="space-y-6" data-id="element-164">
      <div data-id="element-165">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-166">
          Beneficiary Management
        </h1>
        <p className="text-sm text-gray-600 mt-1" data-id="element-167">
          Manage resource collectors (Jele, Moual, Bawali)
        </p>
      </div>

      {/* Tabs */}
      <div className="border-b border-gray-200" data-id="element-168">
        <div className="flex gap-4" data-id="element-169">
          <button onClick={() => setActiveTab('list')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'list' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-170">
            Beneficiary List
          </button>
          <button onClick={() => setActiveTab('add')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'add' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-171">
            Add Beneficiary
          </button>
          <button onClick={() => setActiveTab('approval')} className={`px-4 py-2 border-b-2 font-medium text-sm transition-colors ${activeTab === 'approval' ? 'border-[#1B5E20] text-[#1B5E20]' : 'border-transparent text-gray-600 hover:text-gray-900'}`} data-id="element-172">
            Approval Queue ({pendingApprovals.length})
          </button>
        </div>
      </div>

      {/* Content */}
      {activeTab === 'list' && <DataTable columns={columns} data={beneficiaries} filters={filters} onView={row => console.log('View', row)} onEdit={row => console.log('Edit', row)} onDelete={row => console.log('Delete', row)} searchPlaceholder="Search by name or NID..." data-id="element-173" />}

      {activeTab === 'add' && <WizardForm steps={wizardSteps} currentStep={currentStep} onStepChange={setCurrentStep} onSubmit={() => {
      if (!formData.fullName || !formData.nid || !formData.profession) {
        alert('Please fill in all required fields.');
        return;
      }
      alert(`Beneficiary ${formData.fullName} registered successfully and sent for approval!`);
      setCurrentStep(0);
      setActiveTab('approval');
      // Reset form
      setFormData({
        photo: '',
        fullName: '',
        fatherName: '',
        spouseName: '',
        nid: '',
        birthCertNo: '',
        dob: '',
        age: '',
        gender: '',
        education: '',
        profession: '',
        experience: '',
        groupName: '',
        prevPermit: '',
        division: '',
        village: '',
        union: '',
        upazila: '',
        district: '',
        range: '',
        station: '',
        bloodGroup: '',
        phone: '',
        email: '',
        nidAttachment: '',
        birthCertAttachment: '',
        educationAttachment: ''
      });
    }} data-id="element-174">
          {currentStep === 0 && <div className="space-y-4" data-id="element-175">
              <div className="grid grid-cols-2 gap-4" data-id="element-176">
                <div data-id="element-177">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-178">
                    Photo Upload *
                  </label>
                  <input type="file" accept="image/*" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-179" />
                </div>
                <div data-id="element-180">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-181">
                    Full Name *
                  </label>
                  <input type="text" required value={formData.fullName} onChange={e => setFormData({
              ...formData,
              fullName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-182" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-183">
                <div data-id="element-184">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-185">
                    Father's Name *
                  </label>
                  <input type="text" required value={formData.fatherName} onChange={e => setFormData({
              ...formData,
              fatherName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-186" />
                </div>
                <div data-id="element-187">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-188">
                    Spouse Name
                  </label>
                  <input type="text" value={formData.spouseName} onChange={e => setFormData({
              ...formData,
              spouseName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-189" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-190">
                <div data-id="element-191">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-192">
                    NID Number *
                  </label>
                  <input type="text" required value={formData.nid} onChange={e => setFormData({
              ...formData,
              nid: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-193" />
                </div>
                <div data-id="element-194">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-195">
                    Birth Certificate No.
                  </label>
                  <input type="text" value={formData.birthCertNo} onChange={e => setFormData({
              ...formData,
              birthCertNo: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-196" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-197">
                <div data-id="element-198">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-199">
                    Profession *
                  </label>
                  <select required value={formData.profession} onChange={e => setFormData({
              ...formData,
              profession: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-200">
                    <option value="" data-id="element-201">Select Profession</option>
                    <option value="jele" data-id="element-202">Jele (Fisher)</option>
                    <option value="moual" data-id="element-203">Moual (Honey Collector)</option>
                    <option value="bawali" data-id="element-204">Bawali (Wood Collector)</option>
                  </select>
                </div>
                <div data-id="element-205">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-206">
                    Age *
                  </label>
                  <input type="number" required value={formData.age} onChange={e => setFormData({
              ...formData,
              age: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-207" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-208">
                <div data-id="element-209">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-210">
                    Education
                  </label>
                  <input type="text" value={formData.education} onChange={e => setFormData({
              ...formData,
              education: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-211" />
                </div>
                <div data-id="element-212">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-213">
                    Gender *
                  </label>
                  <select required value={formData.gender} onChange={e => setFormData({
              ...formData,
              gender: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-214">
                    <option value="" data-id="element-215">Select Gender</option>
                    <option value="male" data-id="element-216">Male</option>
                    <option value="female" data-id="element-217">Female</option>
                    <option value="other" data-id="element-218">Other</option>
                  </select>
                </div>
              </div>
            </div>}
          {currentStep === 1 && <div className="space-y-4" data-id="element-219">
              <div className="grid grid-cols-2 gap-4" data-id="element-220">
                <div data-id="element-221">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-222">
                    Division *
                  </label>
                  <select required value={formData.division} onChange={e => setFormData({
              ...formData,
              division: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-223">
                    <option value="" data-id="element-224">Select Division</option>
                    <option value="Khulna" data-id="element-225">Khulna</option>
                    <option value="Barisal" data-id="element-226">Barisal</option>
                    <option value="Dhaka" data-id="element-227">Dhaka</option>
                    <option value="Chattogram" data-id="element-228">Chattogram</option>
                    <option value="Rajshahi" data-id="element-229">Rajshahi</option>
                    <option value="Rangpur" data-id="element-230">Rangpur</option>
                    <option value="Sylhet" data-id="element-231">Sylhet</option>
                    <option value="Mymensingh" data-id="element-232">Mymensingh</option>
                  </select>
                </div>
                <div data-id="element-233">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-234">
                    District *
                  </label>
                  <select required value={formData.district} onChange={e => setFormData({
              ...formData,
              district: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-235">
                    <option value="" data-id="element-236">Select District</option>
                    <option value="Satkhira" data-id="element-237">Satkhira</option>
                    <option value="Khulna" data-id="element-238">Khulna</option>
                    <option value="Bagerhat" data-id="element-239">Bagerhat</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-240">
                <div data-id="element-241">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-242">
                    Upazila *
                  </label>
                  <select required value={formData.upazila} onChange={e => setFormData({
              ...formData,
              upazila: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-243">
                    <option value="" data-id="element-244">Select Upazila</option>
                    <option value="Shyamnagar" data-id="element-245">Shyamnagar</option>
                    <option value="Koyra" data-id="element-246">Koyra</option>
                    <option value="Dacope" data-id="element-247">Dacope</option>
                  </select>
                </div>
                <div data-id="element-248">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-249">
                    Union *
                  </label>
                  <select required value={formData.union} onChange={e => setFormData({
              ...formData,
              union: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-250">
                    <option value="" data-id="element-251">Select Union</option>
                    <option value="Union 1" data-id="element-252">Union 1</option>
                    <option value="Union 2" data-id="element-253">Union 2</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-254">
                <div data-id="element-255">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-256">
                    Village *
                  </label>
                  <select required value={formData.village} onChange={e => setFormData({
              ...formData,
              village: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-257">
                    <option value="" data-id="element-258">Select Village</option>
                    <option value="Munshiganj" data-id="element-259">Munshiganj</option>
                    <option value="Gabura" data-id="element-260">Gabura</option>
                    <option value="Shyamnagar" data-id="element-261">Shyamnagar</option>
                    <option value="Koyra" data-id="element-262">Koyra</option>
                    <option value="Dacope" data-id="element-263">Dacope</option>
                  </select>
                </div>
                <div data-id="element-264">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-265">
                    Range *
                  </label>
                  <select required value={formData.range} onChange={e => setFormData({
              ...formData,
              range: e.target.value,
              station: ''
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-266">
                    <option value="" data-id="element-267">Select Range</option>
                    <option value="Satkhira Range" data-id="element-268">Satkhira Range</option>
                    <option value="Khulna Range" data-id="element-269">Khulna Range</option>
                    <option value="Chandpai Range" data-id="element-270">Chandpai Range</option>
                    <option value="Sarankhola Range" data-id="element-271">Sarankhola Range</option>
                  </select>
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-272">
                <div data-id="element-273">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-274">
                    Station
                  </label>
                  <select value={formData.station} onChange={e => setFormData({
              ...formData,
              station: e.target.value
            })} disabled={!formData.range} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20] disabled:bg-gray-100 disabled:text-gray-400" data-id="element-275">
                    <option value="" data-id="element-276">
                      {formData.range ? 'Select Station' : 'Select Range first'}
                    </option>
                    {formData.range && stationsByRange[formData.range]?.map(station => <option key={station} value={station} data-id="element-277">
                          {station}
                        </option>)}
                  </select>
                </div>
                <div data-id="element-278">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-279">
                    Blood Group
                  </label>
                  <select value={formData.bloodGroup} onChange={e => setFormData({
              ...formData,
              bloodGroup: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-280">
                    <option value="" data-id="element-281">Select Blood Group</option>
                    <option value="A+" data-id="element-282">A+</option>
                    <option value="A-" data-id="element-283">A-</option>
                    <option value="B+" data-id="element-284">B+</option>
                    <option value="B-" data-id="element-285">B-</option>
                    <option value="AB+" data-id="element-286">AB+</option>
                    <option value="AB-" data-id="element-287">AB-</option>
                    <option value="O+" data-id="element-288">O+</option>
                    <option value="O-" data-id="element-289">O-</option>
                  </select>
                </div>
                <div data-id="element-290">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-291">
                    Phone Number *
                  </label>
                  <input type="tel" required value={formData.phone} onChange={e => setFormData({
              ...formData,
              phone: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-292" />
                </div>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-293">
                <div data-id="element-294">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-295">
                    Email Address
                  </label>
                  <input type="email" value={formData.email} onChange={e => setFormData({
              ...formData,
              email: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-296" />
                </div>
              </div>
            </div>}
          {currentStep === 2 && <div className="space-y-4" data-id="element-297">
              <div data-id="element-298">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-299">
                  Profession *
                </label>
                <select required value={formData.profession} onChange={e => setFormData({
            ...formData,
            profession: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-300">
                  <option value="" data-id="element-301">Select Profession</option>
                  <option value="jele" data-id="element-302">Jele (Fisher)</option>
                  <option value="moual" data-id="element-303">Moual (Honey Collector)</option>
                  <option value="bawali" data-id="element-304">Bawali (Wood Collector)</option>
                </select>
              </div>
              <div className="grid grid-cols-2 gap-4" data-id="element-305">
                <div data-id="element-306">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-307">
                    Years of Experience *
                  </label>
                  <input type="number" required value={formData.experience} onChange={e => setFormData({
              ...formData,
              experience: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-308" />
                </div>
                <div data-id="element-309">
                  <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-310">
                    Group/Association Name
                  </label>
                  <input type="text" value={formData.groupName} onChange={e => setFormData({
              ...formData,
              groupName: e.target.value
            })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-311" />
                </div>
              </div>
              <div data-id="element-312">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-313">
                  Previous Permit Number (if any)
                </label>
                <input type="text" value={formData.prevPermit} onChange={e => setFormData({
            ...formData,
            prevPermit: e.target.value
          })} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-314" />
              </div>
            </div>}
          {currentStep === 3 && <div className="space-y-4" data-id="element-315">
              <div data-id="element-316">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-317">
                  NID Copy *
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-318" />
              </div>
              <div data-id="element-319">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-320">
                  Birth Certificate Copy
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-321" />
              </div>
              <div data-id="element-322">
                <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-323">
                  Education Certificate
                </label>
                <input type="file" accept="image/*,application/pdf" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#1B5E20]" data-id="element-324" />
              </div>
            </div>}
          {currentStep === 4 && <div className="space-y-6" data-id="element-325">
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-326">
                <div className="flex items-center justify-between mb-3" data-id="element-327">
                  <h4 className="font-semibold text-gray-900" data-id="element-328">
                    Personal Information
                  </h4>
                  <button onClick={() => setCurrentStep(0)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-329">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-330">
                  <div data-id="element-331">
                    <span className="text-gray-600" data-id="element-332">Name:</span>{' '}
                    <span className="font-medium" data-id="element-333">
                      {formData.fullName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-334">
                    <span className="text-gray-600" data-id="element-335">Father's Name:</span>{' '}
                    <span className="font-medium" data-id="element-336">
                      {formData.fatherName || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-337">
                    <span className="text-gray-600" data-id="element-338">NID:</span>{' '}
                    <span className="font-medium" data-id="element-339">
                      {formData.nid || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-340">
                    <span className="text-gray-600" data-id="element-341">DOB:</span>{' '}
                    <span className="font-medium" data-id="element-342">
                      {formData.dob || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-343">
                <div className="flex items-center justify-between mb-3" data-id="element-344">
                  <h4 className="font-semibold text-gray-900" data-id="element-345">
                    Address & Contact
                  </h4>
                  <button onClick={() => setCurrentStep(1)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-346">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-347">
                  <div data-id="element-348">
                    <span className="text-gray-600" data-id="element-349">Division:</span>{' '}
                    <span className="font-medium" data-id="element-350">
                      {formData.division || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-351">
                    <span className="text-gray-600" data-id="element-352">District:</span>{' '}
                    <span className="font-medium" data-id="element-353">
                      {formData.district || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-354">
                    <span className="text-gray-600" data-id="element-355">Upazila:</span>{' '}
                    <span className="font-medium" data-id="element-356">
                      {formData.upazila || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-357">
                    <span className="text-gray-600" data-id="element-358">Union:</span>{' '}
                    <span className="font-medium" data-id="element-359">
                      {formData.union || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-360">
                    <span className="text-gray-600" data-id="element-361">Village:</span>{' '}
                    <span className="font-medium" data-id="element-362">
                      {formData.village || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-363">
                    <span className="text-gray-600" data-id="element-364">Station:</span>{' '}
                    <span className="font-medium" data-id="element-365">
                      {formData.station || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-366">
                    <span className="text-gray-600" data-id="element-367">Phone:</span>{' '}
                    <span className="font-medium" data-id="element-368">
                      {formData.phone || 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 rounded-lg p-4" data-id="element-369">
                <div className="flex items-center justify-between mb-3" data-id="element-370">
                  <h4 className="font-semibold text-gray-900" data-id="element-371">
                    Professional Details
                  </h4>
                  <button onClick={() => setCurrentStep(2)} className="text-sm text-[#1B5E20] hover:underline" data-id="element-372">
                    Edit
                  </button>
                </div>
                <div className="grid grid-cols-2 gap-3 text-sm" data-id="element-373">
                  <div data-id="element-374">
                    <span className="text-gray-600" data-id="element-375">Profession:</span>{' '}
                    <span className="font-medium capitalize" data-id="element-376">
                      {formData.profession || 'Not provided'}
                    </span>
                  </div>
                  <div data-id="element-377">
                    <span className="text-gray-600" data-id="element-378">Experience:</span>{' '}
                    <span className="font-medium" data-id="element-379">
                      {formData.experience ? `${formData.experience} years` : 'Not provided'}
                    </span>
                  </div>
                </div>
              </div>
            </div>}
        </WizardForm>}

      {activeTab === 'approval' && <DataTable columns={approvalColumns} data={pendingApprovals} onView={row => console.log('View', row)} onApprove={row => alert(`Approved: ${row.name}`)} searchPlaceholder="Search pending approvals..." data-id="element-380" />}
    </div>;
}